import { forwardRef } from "react";

import Icon from "@/components/Icon";
import { type IconProps } from "@/components/Icon/Icon.d";
import RawIcon from "./RawChevronRightIcon.svg.jsx";

const ChevronRightIcon = forwardRef<
  SVGSVGElement,
  Omit<IconProps, "SvgComponent">
>((props, ref) => {
  return <Icon ref={ref} SvgComponent={RawIcon} {...props} />;
});

export default ChevronRightIcon;
